import { defineMessages } from 'react-intl-next';

export const i18n: {
    spotlightDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; spotlightTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	spotlightTitle: {
		id: 'company-hub.spotlight-extension.hub-element.title',
		defaultMessage: 'Spotlight',
		description: 'A visible text label to be used as the title for the spotlight element',
	},
	spotlightDescription: {
		id: 'company-hub.spotlight-extension.hub-element.description',
		defaultMessage: 'Highlight important messages',
		description: 'A visible text label to be used as the description for the spotlight element',
	},
});
